import controller from './otp-expire-dialog.controller';

export default {
  controller,
  template: require('./otp-expire-dialog.html')
};


// WEBPACK FOOTER //
// src/app/no-auth/components/otp-expire-dialog/otp-expire-dialog.component.ts